// Accounts.admin
const CONTRACT_ADMIN = {
    // User
    USER: 0,
    // Admin
    ADMIN: 1,
};
// 表示モード
const CONTRACT_DISPLAY_MODE_TYPE = {
    // 無料期間
    FREE: 1,
    // 無料期間外
    FREE_EXPIRED: 2,
    // 有料プラン
    STANDARD: 3,
    // 停止
    STOP: 4,
};
// Valid
const CONTRACT_VALID = {
    // 無料期間
    INVALID: 0,
    // 無料期間外
    VALID: 1,
};

export default {
    methods: {
        isValidWater(acinfo) {
            if (acinfo) {
                if (acinfo.admin === CONTRACT_ADMIN.ADMIN) {
                    return true;
                }
                if (acinfo.display_mode) {
                    if (acinfo.display_mode.water_management === CONTRACT_VALID.VALID) {
                        return true;
                    }
                }
            }
            return false;
        },

        isAccountExpired(acinfo) {
            if (acinfo) {
                if (acinfo.admin === CONTRACT_ADMIN.ADMIN) {
                    return false;
                }
                if (acinfo.display_mode) {
                    if (
                        acinfo.display_mode.type === CONTRACT_DISPLAY_MODE_TYPE.FREE ||
                        acinfo.display_mode.type === CONTRACT_DISPLAY_MODE_TYPE.STANDARD
                    ) {
                        return false;
                    }
                }
            }
            return true;
        },

        isAccountFree(acinfo) {
            if (acinfo) {
                if (acinfo.admin === CONTRACT_ADMIN.ADMIN) {
                    return false;
                }
                if (acinfo.display_mode) {
                    if (acinfo.display_mode.type > CONTRACT_DISPLAY_MODE_TYPE.FREE_EXPIRED) {
                        return false;
                    }
                }
            }
            return true;
        },
    },
};
